import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import { ColourSchemeProvider } from "./theme/ColourSchemeProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // An operations console is read-heavy and its data changes underneath the user.
      // Short freshness with refetch-on-focus means someone coming back to a stock screen
      // sees current numbers without hammering the API while they work.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element.");
}

createRoot(container).render(
  <StrictMode>
    <ColourSchemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ColourSchemeProvider>
  </StrictMode>,
);
